import React from 'react'
import { Input, Card, Tooltip } from 'antd'
import { useFormikContext } from 'formik'
import { FormField } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const ExpandableContentSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const titlePath = useFieldPath('sections.expandableContent.title')
  const htmlPath = useFieldPath('sections.expandableContent.html')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>Título</label>
        <Input
          name={titlePath}
          value={get(values, titlePath, '')}
          onChange={handleChange}
          placeholder="Ex: Profissionalização no transporte coletivo"
        />
      </FormField>

      <FormField>
        <label>
          <Tooltip title="HTML completo com headings, parágrafos, listas, etc. Este conteúdo será renderizado com dangerouslySetInnerHTML">
            HTML Rico
          </Tooltip>
        </label>
        <TextArea
          name={htmlPath}
          value={get(values, htmlPath, '')}
          onChange={handleChange}
          rows={15}
          placeholder="HTML completo com <p>, <h4>, <ul>, etc."
        />
      </FormField>
    </Card>
  )
}
